const SlotsBookedTrendChart = (data = [
  { date: 'Jul 1', bookings: 24 },
  { date: 'Jul 2', bookings: 31 },
  { date: 'Jul 3', bookings: 28 }
]) => ({
  tooltip: { trigger: 'axis' },
  legend: { show: false },
  grid: { left: 40, right: 20, bottom: 50, top: 40 },
  xAxis: {
    type: 'category',
    data: data.map(item => item.date)
  },
  yAxis: { type: 'value', name: 'Bookings' },
  series: [
    {
      name: 'Bookings',
      type: 'bar',
      barWidth: 30,
      data: data.map(item => item.bookings),
      itemStyle: { color: '#36B37E' }
    },
    {
      name: 'Trend',
      type: 'line',
      data: data.map(item => item.bookings),
      symbol: 'circle',
      symbolSize: 8,
      lineStyle: { color: '#4C9AFF' }
    }
  ]
});

export default SlotsBookedTrendChart;